// Date-only strings from the API ("2009-01-01") are parsed by `new Date`
// as UTC midnight. In US timezones that instant is still the previous evening,
// so January 1st labels shift to the prior year (the "2008" axis bug).
export function parseLocalDate(value) {
  if (value == null || value === '') return null;
  if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value;

  const match = String(value).trim().match(/^(\d{4})-(\d{2})(?:-(\d{2}))?/);
  if (match) {
    const year = Number(match[1]);
    const month = Number(match[2]);
    const day = match[3] ? Number(match[3]) : 1;
    return new Date(year, month - 1, day);
  }

  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

export function formatLocalDate(value, options) {
  const date = parseLocalDate(value);
  if (!date) return '';
  return date.toLocaleDateString('en-US', options);
}
